import { retrieveToken } from '../storage';
import {
  wrapFetch,
  apiFetch,
  apiError,
  CARICAMENTO_IMMAGINE_NON_VALIDA,
} from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const updateProceduraHaccp = (requestBody) => {
  const PATH = '/api/paragrafi/procedurehaccp';
  const URL = BASE_URL + PATH;
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: 'Si è verificato un errore durante il salvataggio.',
    }),
  );
};

export const uploadProceduraImage = (file) => {
  const PATH = '/api/paragrafi/procedurehaccp/immagini/';
  const URL = BASE_URL + PATH;
  let formData = new FormData();
  formData.append('file', file);
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      body: formData,
    }),
    apiError({
      400: CARICAMENTO_IMMAGINE_NON_VALIDA,
      413: CARICAMENTO_IMMAGINE_NON_VALIDA,
    }),
  );
};

export const getControlliSenzaAttrezzature = (manualeId) => {
  const token = retrieveToken();
  const authtoken = `Bearer ${token}`;
  const PATH = `/api/paragrafi/procedurehaccp/controlli_senza_attrezzature?manualeId=${manualeId}`;
  const URL = BASE_URL + PATH;

  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
